window.app.controller('articleCtrl', ['$scope', '$http', function ($scope, $http) {

    $scope.articleRating;
    $scope.newRating = $scope.articleRating;
    $scope.starsPieces = $(".rate > input");
    $scope.isRatingSetted = false;

    $scope.saveRatingData = (rating, id) => {
        // $scope.articleRating = Math.round(rating);
        $scope.articleRating = Math.round(rating * 100) / 100;
        $scope.id = id;
    }

    $scope.initiateRating = () => {
        // for (let i = 0; i < $scope.starsPieces.length; i++) {
        //     if ($scope.starsPieces[i].value == $scope.articleRating) {
        //         $scope.starsPieces[i].checked = true; 
        //     }
        // }
        $('.rateit').rateit('value', $scope.articleRating)
    }


    $(".rateit").bind('rated', function (event, value) {
        if (!$scope.isRatingSetted) {
            $scope.newRating = value;
            $scope.isRatingSetted = true;
            $(".actual-rating").html(this.value)
            $(".rating__tip").css({ "visibility": "visible", "opacity": 1 });
            // $scope.disableSelectionNewRating();
            $('.rateit').rateit('readonly', true);
            $scope.sendNewRating();
        }
    });

    $(".rateit").bind('over', function (event, value) {
        if (!$scope.isRatingSetted) {
            $(".actual-rating").html(value)
        }
    });

    // $(".rate > label").hover(function() {
    //     if (!$scope.isRatingSetted) {
    //         $(".actual-rating").html(this.title)
    //     }
    // });

    $(".rateit").mouseleave(function () {
        $scope.newRating ? $(".actual-rating").html($scope.newRating) : $(".actual-rating").html($scope.articleRating);
    });

    // $scope.starsPieces.click(function setNewRating() {
    //     if (!$scope.isRatingSetted) {
    //         $scope.newRating = this.value;
    //         $scope.isRatingSetted = true;
    //         $(".rating__tip").css({"visibility": "visible", "opacity": 1});
    //         $(".actual-rating").html(this.value)
    //         $scope.disableSelectionNewRating();
    //         $scope.sendNewRating();
    //     }
    // })

    $scope.sendNewRating = () => {
        $scope.sendXHR({
            url: `/api/front/blog/blog/add-rating`,
            data: {
                id: $scope.id,
                rating: $scope.newRating
            },
            successFunc: $scope.updateViewRating
        });
    }

    $scope.updateViewRating = (resp) => {
        console.log(resp)
        // $scope.articleRating = resp.data.rating;
        // $scope.votersNumber = resp.data.votes;
        // $scope.initiateRating();
        // $scope.initiateStaticRating();
    }

    // $scope.disableSelectionNewRating = () => {
    //     $scope.starsPieces.attr("disabled", true);
    //     $(".rate").removeClass("hovered-rating");
    // }

    $scope.initiateStaticRating = () => {
        let width = "0%";
        if ($scope.articleRating) {
            width = ($scope.articleRating / 5 * 100) + "%";
        }
        document.styleSheets[0].insertRule(`#star-ratings-css:after { width: ${width}; }`, 0);
    }

    $(document).ready(function () {
        $scope.initiateStaticRating();
        $scope.initiateRating();
        // sessionStorage.getItem("wasRated") ? $scope.disableSelectionNewRating() : "";
        // $scope.isRatingSetted ? $scope.disableSelectionNewRating() : "";
    });



}])


// WEBPACK FOOTER //
// src/js/controllers/blog/articleCtrl.js